import { useEffect, useMemo } from 'react'
import { collection } from 'firebase/firestore'
import {
  type CollectionListenerCallback,
  firestoreListenersManager,
} from '@/shared/lib/firestore-listeners-manager'
import { db } from '../../firebase'
import { RUNDOWN_COLLECTION, CELL_COLLECTION } from '@rundown-studio/consts'
import { useAtomValue } from 'jotai'
import { rundownAtom } from '../../store/rundown.store'

export function useCellListener(callback: CollectionListenerCallback) {
  const rundown = useAtomValue(rundownAtom)

  const rundownId = useMemo(() => rundown?.id, [rundown])

  useEffect(() => {
    if (!rundownId) return

    const collectionRef = collection(
      db,
      RUNDOWN_COLLECTION,
      rundownId,
      CELL_COLLECTION,
    )

    const unsubscribe = firestoreListenersManager.subscribeToCollection(
      collectionRef,
      callback,
    )

    return () => unsubscribe()
    // Do not depend on a callback. It is hard to debug its logic, and it might trigger infinite re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rundownId])
}
